package com.castly.admin.dto

import kotlinx.serialization.Serializable

@Serializable
data class ContinueWatchingItem(
    val contentId: String,
    val contentType: String,
    val title: String,
    val coverImageUrl: String? = null,
    val episodeId: String,
    val episodeTitle: String,
    val episodeImageUrl: String? = null,
    val positionSeconds: Int,
    val durationSeconds: Int? = null,
    val progressPercent: Int,
    val updatedAt: String
)

@Serializable
data class ContinueWatchingResponse(
    val items: List<ContinueWatchingItem>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)

@Serializable
data class StreamProgressResponse(
    val episodeId: String,
    val positionSeconds: Int,
    val durationSeconds: Int? = null,
    val isCompleted: Boolean,
    val progressPercent: Int,
    val updatedAt: String
)
